import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export function sampleTableCol(searchArr) {
    let filteredInfo = changeFilteredInfo(searchArr)
    return [
        {
            title: '送样样品名',
            dataIndex: 'sampleName',
            key: 'sampleName',
            sorter: true,
            searchMethod: 'LIKE',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.sampleName || [],
        },
        {
            title: '分析样品名',
            dataIndex: 'analyzeName',
            key: 'analyzeName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.analyzeName || [],

        },
        {
            title: '原始样品分组',
            dataIndex: 'groupName',
            key: 'groupName',
            sorter: true,
            sortDirections: ["ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.groupName || [],
        },

        {
            title: '样品类型',
            dataIndex: 'sampleTypeName',
            key: 'sampleTypeName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.sampleTypeName || [],
        }, {
            title: '样品来源',
            dataIndex: 'sampleSource',
            key: 'sampleSource',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.sampleSource || [],
        },
        {
            title: '物种/宿主',
            dataIndex: 'speciesName',
            key: 'speciesName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.speciesName || [],
        },

        {
            title: '保存方式',
            dataIndex: 'howToSave',
            key: 'howToSave',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.howToSave || [],
        },
        {
            title: '合同数据量',
            dataIndex: 'planAmount',
            key: 'planAmount',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdownNum',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.planAmount || [],
        },
        {
            title: '原始数据释放时间',
            dataIndex: 'releaseTime',
            key: 'releaseTime',
        },

    ]
}


